import style from "./index.module.css";
import more_icon from "assets/images/icons/icon-more-two.svg";
import { useState } from "react";
import { useEffect } from "react";
import AddedEvent from "components/addedEvent";

const MoreBtn = ({ more, more_icon_btn }) => {
    const [visible1, setVisible1] = useState(false);
    const [showResults, setShowResults] = useState(false);
  
    const toggle = () => setShowResults(!showResults);
    const show1 = () => setVisible1(!visible1);
  
    return (
      <>
        <div onClick={() => setShowResults(true)} className={style.more}>
          {more_icon_btn}
        </div>
        {showResults && (
          <div className={style.more_card}>
            {more.map((item, index) => (
              <div
                className={style.more_item}
                onClick={() => [toggle(), index + 1 === 1 ? show1() : null]}
                key={index}
              >
                {item.image}
                {item.text}
              </div>
            ))}
          </div>
        )}
        {visible1 && <AddedEvent visible={setVisible1} />}
      </>
    );
  };
  
  export default MoreBtn;
